import { render, staticRenderFns } from "./TestTable.vue?vue&type=template&id=137dbbe3&scoped=true&"
import script from "./TestTable.vue?vue&type=script&lang=js&"
export * from "./TestTable.vue?vue&type=script&lang=js&"
import style0 from "./TestTable.vue?vue&type=style&index=0&id=137dbbe3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137dbbe3",
  null
  
)

export default component.exports